export default "__VITE_ASSET__Brq$B6tb__"